<template>
  <div :class="[`${pageClass}-box-main_cont`]" v-loading="paperLoading">
    <div class="main-detail-right">
      <div class="detail-right-box" ref="detail-right-box">
        <div class="center" v-loading="detailLoading">
          <template v-if="paper.coverMap">
            <img
              class="left"
              :src="`${backURL}/apis/upload/${paper.coverMap}`"
              alt=""
            />
          </template>
          <template v-else>
            <img
              v-if="paper.subjectId == 11"
              class="left"
              src="../../assets/images/paper/yy.jpg"
              alt=""
            />
            <img
              v-if="paper.subjectId == 10"
              class="left"
              src="../../assets/images/paper/sx.jpg"
              alt=""
            />
            <img
              v-if="paper.subjectId == 9"
              class="left"
              src="../../assets/images/paper/yw.jpg"
              alt=""
            />
            <img
              v-if="paper.subjectId == 12"
              class="left"
              src="../../assets/images/paper/wl.jpg"
              alt=""
            />
            <img
              v-if="paper.subjectId == 13"
              class="left"
              src="../../assets/images/paper/hx.jpg"
              alt=""
            />
            <img
              v-if="paper.subjectId == 14"
              class="left"
              src="../../assets/images/paper/sw.jpg"
              alt=""
            />
          </template>
          <div class="right">
            <!-- <p class="title" v-if="paper.id !=null && paperData.length && paperData[0].id == paper.id">免费体验【{{ paper.pname }}】</p>
            <p class="title" v-else>{{ paper.pname }}</p> -->
            <p class="title">{{ paper.pname }}</p>
            <div class="p-time">
              <span style="display: inline-block; width: 280px"
                >试题数量：<span class="text">{{
                  paper.questionCount ? paper.questionCount : 0
                }}</span></span
              >
              答题时间：
              <span class="text"
                >{{ paper.duration ? paper.duration : 0 }}分钟</span
              >
            </div>
            <div class="p-time">
              <span style="display: inline-block; width: 280px"
                >主讲专家：<span class="text">{{ paper.speaker }}</span></span
              >
              试题精讲时长：
              <span class="text"
                >{{ paper.allDuration ? paper.allDuration : 0 }}分钟</span
              >
            </div>
            <!-- <div class="p-time">
              <span style="display: inline-block; width: 280px"
                >更新时间：
                <span class="text">{{
                  paper.publishedTime
                    ? new Date(paper.publishedTime).format("yyyy-MM-dd")
                    : "0000-00-00"
                }}</span></span
              >
               <template v-if="!paper.pname.includes('冲刺')">
                周次：<span class="text">第{{paper.weekNo}}周</span>
              </template> 
            </div> -->
            <div class="price">
              <el-button class="button-right" @click="doPaper" :loading="shows"
                >开始测评</el-button
              >
            </div>
          </div>
        </div>

        <div class="introduce">
          <div class="introduce-tab">
            <ul>
              <!-- <li v-if="paper.id !=null && paperData.length && paperData[0].id == paper.id" :class="{ active: active == 3, 'first-li':  paper.id !=null && paperData.length && paperData[0].id == paper.id  }" @click="getBlockedOut(3)">
                {{ selectSubjects }}提分秘籍
              </li> -->
              <!-- <li v-if="paper.id !=null && paperData.length && paperData[0].id == paper.id" :class="{ active: active == 4, 'first-li':  paper.id !=null && paperData.length && paperData[0].id == paper.id  }" @click="getBlockedOut(4)">
                试卷上线计划
              </li> -->
              <!-- <li v-if="paper.id !=null && paperData.length && paperData[0].id == paper.id" :class="['first-li', {active: active == 1}]" @click="getBlockedOut(1)">
                <span>试卷介绍</span>
              </li>
              <li v-if="paper.id !=null && paperData.length && paperData[0].id == paper.id" :class="['first-li', {active: active == 2}]" @click="getBlockedOut(2)">
                <span>专家介绍</span>
              </li> -->
              <li :class="{ active: active == 1 }" @click="getBlockedOut(1)">
                <span>试卷介绍</span>
              </li>
              <li :class="{ active: active == 2 }" @click="getBlockedOut(2)">
                <span>专家介绍</span>
              </li>
            </ul>
          </div>
          <div class="content" v-show="active == 1">
            <!-- <div v-if="paper.descPicture" class="pic" v-html="paper.descPicture"></div> -->

            <!-- 自适应高度,但iframe不能跨域 -->
            <iframe
              name="ifd"
              onload="this.height=ifd.document.body.scrollHeight + 40"
              width="100%"
              frameborder="0"
              scrolling="no"
              v-show="paper.descPicture"
              :src="`${backURL}/apis/upload/${paper.descPicture}`"
            ></iframe>
            <div v-show="!paper.descPicture" class="nocountent">
              <img src="../../assets/images/home/nocountent.jpg" alt="" />
              <p>暂无试卷介绍</p>
            </div>
          </div>
          <div class="content" v-show="active == 2">
            <img
              v-show="paper.descSpeakerPicture"
              class="pic"
              :src="`${backURL}/apis/upload/${paper.descSpeakerPicture}`"
              alt=""
            />
            <div class="nocountent" v-show="!paper.descSpeakerPicture">
              <img src="../../assets/images/home/nocountent.jpg" alt="" />
              <p>暂无专家介绍</p>
            </div>
          </div>
          <!-- <div class="content" v-if="active == 3">
            <iframe v-if="paper.improveScore" :src="`${ backURL }/apis/upload/${paper.improveScore}`"></iframe>
            <div class="nocountent" v-else>
              <img src="../../assets/images/home/nocountent.jpg" alt="">
              <p>暂无提分秘籍</p>
            </div>
          </div> -->
          <div class="content" v-if="active == 4">
            <iframe
              allowfullscreen="true"
              v-if="paper.improveScore && subjectActive == 9"
              :src="`${backURL}/apis/upload/gk-resource/explan/yw/index.html`"
            ></iframe>
            <iframe
              allowfullscreen="true"
              v-else-if="paper.improveScore && subjectActive == 10"
              :src="`${backURL}/apis/upload/gk-resource/explan/sx/index.html`"
            ></iframe>
            <iframe
              allowfullscreen="true"
              v-else-if="paper.improveScore && subjectActive == 11"
              :src="`${backURL}/apis/upload/gk-resource/explan/yy/index.html`"
            ></iframe>
            <iframe
              allowfullscreen="true"
              v-else-if="paper.improveScore && subjectActive == 12"
              :src="`${backURL}/apis/upload/gk-resource/explan/wl/index.html`"
            ></iframe>
            <div class="nocountent" v-else>
              <img src="../../assets/images/home/nocountent.jpg" alt="" />
              <p>暂无专家上线计划</p>
            </div>
          </div>
        </div>
        <el-dialog
          v-if="dialogVisible"
          :visible.sync="dialogVisible"
          custom-class="pay-dialod-visible"
          @close="closeDialog"
        >
          <div class="count">
            <div v-if="!wxPay" class="zfb_box">
              <!-- 新用户  -->
              <div v-if="isVip == 1" class="foot-vip">
                <div class="has_active_price" style="width: 200px">
                  <span>定价：</span>￥200
                  <span class="lineation vipPreferential" style="display: block"
                    >成为会员享受更多优惠</span
                  >
                </div>
                <div class="pay_types">请选择支付方式</div>
                <div class="right_f">
                  <div class="wx" @mouseenter="wxEnter" @mouseleave="wxLeave">
                    <img
                      src="../../assets/images/main/wx.png"
                      alt=""
                      @click="weChatPayment"
                    />
                  </div>
                  <div class="zfb" @click="alipayPayment">
                    <img src="../../assets/images/main/zfb.png" alt="" />
                  </div>
                </div>
                <div style="margin-top: 20px; float: left; padding: 30px">
                  您当前账号为VIP账号,还可以免费体验产品90天,可点击下方按钮直接答题
                </div>
                <div class="btn-container">
                  <el-button @click="toPaper(paper.appId, paper.id)"
                    >立即体验</el-button
                  >
                </div>
              </div>

              <div v-else>
                <!-- <template v-if="hasActive && (activeInfo.name != null && activeInfo.name)"> -->
                <div
                  v-if="
                    ((hasActive && limitSubject == 0) ||
                      (hasActive && showActive)) &&
                    (activeInfo.times - paperAlltotal > 0 ||
                      surplusSingleFamily > 0)
                  "
                  class="has_active"
                >
                  <img
                    class="vip_card"
                    src="../../assets/images/vip/vip.jpg"
                    alt=""
                    @click.stop="buyVip"
                  />
                  <div class="has_active_price">
                    ￥{{
                      orderInfo.orderAmount != null &&
                      orderInfo.orderAmount != undefined
                        ? orderInfo.orderAmount
                        : 200
                    }}
                    <span class="lineation" style="display: block"
                      >成为会员享受更多优惠</span
                    >
                  </div>
                  <div class="new_user">注册用户优惠</div>
                  <div class="new_user_name">{{ activeInfo.name }}</div>
                  <div class="pay_type" v-if="orderInfo.orderAmount !== 0">
                    请选择支付方式
                  </div>

                  <!-- 不限学科 -->
                  <div v-if="limitSubject == 0">
                    <p class="tips_d">
                      您还有{{
                        activeInfo.times - paperAlltotal
                      }}次优惠答题机会哦，快来体验吧！
                    </p>
                  </div>

                  <!-- 限学科 -->
                  <div v-if="limitSubject == 1">
                    <p class="tips_d">
                      您还有{{ surplusSingleFamily }}次{{
                        selectSubjects
                      }}学科优惠答题机会，快来体验吧！
                    </p>
                  </div>
                  <div class="right_d" v-if="orderInfo.orderAmount !== 0">
                    <div class="wx" @mouseenter="wxEnter" @mouseleave="wxLeave">
                      <img
                        src="../../assets/images/main/wx.png"
                        alt=""
                        @click="weChatPayment"
                      />
                    </div>
                    <div class="zfb" @click="alipayPayment">
                      <img src="../../assets/images/main/zfb.png" alt="" />
                    </div>
                  </div>

                  <div
                    v-if="
                      orderInfo.orderAmount != null &&
                      orderInfo.orderAmount == 0
                    "
                    style="width: 100%; margin-top: 105px"
                  >
                    <el-button
                      @click="toPaper(paper.appId, paper.id)"
                      style="
                        background: #1890ff;
                        margin: 0 auto;
                        color: #fff;
                        display: block;
                      "
                      >立即体验</el-button
                    >
                  </div>
                </div>
                <div v-else>
                  <img
                    class="vip_card"
                    src="../../assets/images/vip/vip.jpg"
                    alt=""
                    @click.stop="buyVip"
                  />
                  <div class="has_active_price">
                    <span>定价：</span>￥{{
                      orderInfo.orderAmount ? orderInfo.orderAmount : 200
                    }}
                    <span class="lineation" style="display: block"
                      >成为会员享受更多优惠</span
                    >
                  </div>
                  <div class="pay_types">请选择支付方式</div>
                  <div class="right_f">
                    <div class="wx" @mouseenter="wxEnter" @mouseleave="wxLeave">
                      <img
                        src="../../assets/images/main/wx.png"
                        alt=""
                        @click="weChatPayment"
                      />
                    </div>
                    <div class="zfb" @click="alipayPayment">
                      <img src="../../assets/images/main/zfb.png" alt="" />
                    </div>
                    <div class="balance" v-if="model == 'client'">
                      <div class="left">
                        <img src="@/assets/images/client/qianbao.png" alt="" />
                        <div class="msg">
                          <span>余额</span>
                          <span style="color: #ff0000">{{ price }}</span>
                          <span
                            style="font-size: 14px; color: #ff0000"
                            v-if="balanceShow"
                            >（不足支付）</span
                          >
                        </div>
                      </div>
                      <button
                        class="right"
                        v-if="balanceShow"
                        @click="openWindows"
                      >
                        充值
                      </button>
                      <button class="right" v-else @click="balancePayment">
                        支付
                      </button>
                    </div>
                  </div>
                </div>
                <!-- </template> -->
              </div>
            </div>

            <div v-else class="wx_box">
              <h3>微信扫描二维码完成支付</h3>
              <div class="price">
                <span>实付金额：</span><span style="color: #e50001">￥</span>
                <span class="p_num_new">{{ orderInfo.orderAmount }}</span>
              </div>
              <div class="right">
                <div class="right_QrCode">
                  <qrCode
                    class="right_QrCode_img"
                    v-if="payCodeUrl"
                    :pay-code-url="payCodeUrl"
                  ></qrCode>
                </div>
              </div>
              <p class="pOne">
                打开微信【扫一扫】扫描上方的二维码，按操作提示完成支付
              </p>
              <p class="pOne">请在2小时内完成操作，超时后需要重新开始购买</p>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>

    <div v-html="html"></div>
    <el-dialog
      v-if="dialogVisibleSelectType"
      title="请选择作答方式"
      center
      :visible.sync="dialogVisibleSelectType"
      custom-class="paper-type-dialod-visible"
    >
      <ul>
        <li
          v-if="havdoInfo.questionTypeList.includes(1)"
          @click="dialogActive = 1"
        >
          <span>仅做未做题</span>
          <img
            class="selest"
            v-if="dialogActive == 1"
            src="@/assets/images/client/dui-ok.jpg"
            alt=""
            @click="dialogActive == 1"
          />
          <img
            class="selest"
            v-else
            src="@/assets/images/client/dui.png"
            alt=""
          />
        </li>
        <li
          v-if="havdoInfo.questionTypeList.includes(2)"
          @click="dialogActive = 2"
        >
          <span>仅做错题</span>
          <img
            class="selest"
            v-if="dialogActive == 2"
            src="@/assets/images/client/dui-ok.jpg"
            alt=""
            @click="dialogActive == 2"
          />
          <img
            class="selest"
            v-else
            src="@/assets/images/client/dui.png"
            alt=""
          />
        </li>
        <li
          v-if="havdoInfo.questionTypeList.includes(3)"
          @click="dialogActive = 3"
        >
          <span>做错题和未做题</span>
          <img
            class="selest"
            v-if="dialogActive == 3"
            src="@/assets/images/client/dui-ok.jpg"
            alt=""
            @click="dialogActive == 3"
          />
          <img
            class="selest"
            v-else
            src="@/assets/images/client/dui.png"
            alt=""
          />
        </li>
        <li
          v-if="havdoInfo.questionTypeList.includes(4)"
          @click="dialogActive = 4"
        >
          <span>重新作答</span>
          <img
            class="selest"
            v-if="dialogActive == 4"
            src="@/assets/images/client/dui-ok.jpg"
            alt=""
            @click="dialogActive == 4"
          />
          <img
            class="selest"
            v-else
            src="@/assets/images/client/dui.png"
            alt=""
          />
        </li>
      </ul>
      <button @click="selectPaper">确定</button>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogVisibleShow" width="30%">
      <span
        >此套试卷，你尚有未自评的试题,请在我的学习中完成自评后，继续答题。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleShow = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { resource } from "../../mixins/my_personal";
import evaluationType from "ASSETS/js/evaluation-type.js";
import elPages from "../../components/page/index";
import qrCode from "@/components/qr-code/qr-code-for-wxpay";
import $ from "jquery";
export default {
  name: "select_subject",
  mixins: [resource],
  data() {
    return {
      dialogVisibleShow: false,
      paperLoading: true,
      havdoInfo: {},
      dialogActive: null, // 选择做题方式
      model: "",
      goodsId: 0,
      activeli: null,
      answerTimes: 0,
      monthNum: 0,
      isAgent: false,
      agentInfo: {},
      shows: false,
      html: "",
      wxPay: false, // 微信支付
      dialogVisible: false,
      active: 1,
      backURL: this.$config.backURL,
      evaluationType,
      pageClass: "select_subject",
      userInfo: {},
      structure: true, // 结构展示形式
      paperData: [],
      loading: false,
      totalCount: 0, // 总页数
      timeInterval: [], // 时间区间
      tabActive: 0,
      subjectActive: -1, // 学科选中时下标
      dialogVisibleSelectType: false,
      params: {
        // 筛选条件
        orderBy: "3",
        rule: 1,
        subjectId: null,
        appId: 100,
        dateType: null,
        pageIndex: 1,
        pageSize: 100
      },
      paper: {},
      detailLoading: false,
      subjectData: [],
      subjectList: [
        {
          id: 10,
          label: "数学"
        },
        {
          id: 12,
          label: "物理"
        },
        {
          id: 11,
          label: "英语"
        },
        {
          id: 9,
          label: "语文"
        },
        {
          id: 13,
          label: "化学"
        },
        {
          id: 14,
          label: "生物"
        },
        {
          id: 16,
          label: "地理"
        },
        {
          id: 15,
          label: "历史"
        },
        {
          id: 17,
          label: "政治"
        }
      ],
      orderInfo: {},
      isLogin: false,
      wxShow: false,
      payCodeUrl: undefined,
      isVip: 0,
      hasActive: false,
      activeInfo: {
        subjectList: []
      },
      paperAlltotal: 0, // 活动期间任意学科购买总数
      singleFamily: 0, //  活动期间单科购买次数
      limitSubject: 0, // 是否限制学科 0 不限学科 1 限制学科
      subjectShowPreferential: [], // 展示的学科数组
      oldUser: 0, // 查看老用户购买次数
      price: 0, // 余额信息
      testId: null
    };
  },
  components: {
    elPages,
    qrCode
  },
  watch: {
    dialogVisibleSelectType(val) {
      if (val == false) {
        this.dialogActive = null;
      }
    }
  },
  computed: {
    balanceShow() {
      let pic = this.orderInfo.orderAmount ? this.orderInfo.orderAmount : 200;
      if (pic > this.price) {
        return true; // 显示充值
      } else {
        return false;
      }
    },
    showActive() {
      for (let i = 0; i < this.subjectShowPreferential.length; i++) {
        const element = this.subjectShowPreferential[i];
        if (element == this.subjectActive) {
          return true;
        }
      }
      return false;
    },
    surplusSingleFamily() {
      // 限学科
      if (
        this.activeInfo.subjectList != null &&
        this.activeInfo.subjectList.length > 0
      ) {
        for (let i = 0; i < this.activeInfo.subjectList.length; i++) {
          const element = this.activeInfo.subjectList[i];
          if (element.subjectId == this.subjectActive) {
            return Number(element.times) - Number(this.singleFamily);
          }
        }
      }
      return 0;
    },
    selectSubjects() {
      for (let i = 0; i < this.subjectList.length; i++) {
        const element = this.subjectList[i];
        if (element.id == this.subjectActive) {
          return element.label;
        }
      }
      return "语文";
    }
  },
  methods: {
    // 选择重新作答的答题方式
    selectPaper() {
      // type 1 错题 2 未做答 3 错题 和 未做答
      if (!this.dialogActive) {
        this.$message.error("请选择作答方式");
      } else if (this.dialogActive == 4 || this.dialogActive == 5) {
        this.$router.push({
          path: "/paper/paper",
          query: {
            paper_id: this.paper.id,
            app_id: 100,
            order_number: this.orderInfo.orderNumber || "",
            question_type: this.dialogActive,
            test_id: this.testId
          }
        });
      } else {
        this.$router.push({
          path: "/paper_hav_do",
          query: {
            id: this.paper.id,
            app_id: 100,
            type: this.dialogActive,
            test_id: this.testId
          }
        });
      }
    },
    getPaperHavDo() {
      this.$HTTP
        .executeGet(`${this.$APIS.GET_START_ANSWERING}/${this.paper.id}`, this)
        .then(res => {
          this.havdoInfo = res.data;
          this.shows = false;
          this.testId = res.data.testId;
          if (res.code === 0) {
            // 测评过
            if (this.havdoInfo.questionTypeList.includes(5)) {
              this.$router.push({
                path: "/paper/paper",
                query: {
                  paper_id: this.paper.id,
                  app_id: 100,
                  order_number: this.orderInfo.orderNumber || "",
                  question_type: 5,
                  test_id: this.testId
                }
              });
            } else if (this.havdoInfo.questionTypeList.includes(-1)) {
              // 继续作答
              this.$router.push({
                path: "/continue_evaluation_zj",
                query: {
                  id: this.havdoInfo.testId,
                  paper_id: this.paper.id,
                  app_id: 100,
                  question_type: -1
                }
              });
            } else if (this.havdoInfo.questionTypeList.includes(-2)) {
              // 继续作答
              this.dialogVisibleShow = true;
              // this.$message.error('此套试卷，你尚有未自评的试题,请在我的学习中完成自评后，继续答题')
            } else {
              this.dialogVisible = false;
              this.dialogVisibleSelectType = true;
            }
          } else if (res.code === 1) {
            // 没有测评过 初次做答
            this.$router.push({
              path: "/paper/paper",
              query: {
                paper_id: this.paper.id,
                app_id: 100,
                order_number: this.orderInfo.orderNumber || "",
                question_type: 5,
                test_id: this.testId
              }
            });
          } else if (res.code === 2) {
            this.$message.error(res.message);
          }
        });
    },
    doPaper() {
      this.dialogActive = null;
      if (this.model != "client") {
        this.$message.error("请下载客户端答题！");
        return false;
      }
      this.buyProcurement(this.paper.id);
    },
    openWindows() {
      try {
        cefJS.sendmsg("balance");
        this.dialogVisible = false;
      } catch (error) {
        console.log(error);
      }
    },
    balancePayment() {
      this.$HTTP
        .executeGet(
          `${this.$APIS.PAY_BALANCE_PAPER}/${this.orderInfo.orderNumber}`,
          this
        )
        .then(res => {
          const { data, code, msg } = res;
          if (code == 0) {
            if (this.model != "client") {
              this.$message.error("请下载客户端答题！");
              this.shows = false;
            } else {
              this.getPaperHavDo();
            }
          }
        });
    },
    buyVip() {
      this.$router.push({
        path: "/tfedu_common/buy_members"
      });
    },
    alipayTranslation() {
      this.wxPay = false;
    },
    quertOrderStatus() {
      // 查看订单状态
      this.$HTTP
        .executePost(
          this.$APIS.QUERY_TRADE_STATUS,
          { orderNumber: this.orderInfo.orderNumber },
          this
        )
        .then(resD => {
          if (resD.code == 0) {
            // 支付成功
            if (resD.data != null && resD.data == "1") {
              if (this.model != "client") {
                this.$message.error("请下载客户端答题！");
                this.shows = false;
              } else {
                this.getPaperHavDo();
              }
            } else {
              setTimeout(() => {
                this.quertOrderStatus();
              }, 2000);
            }
          }
        });
    },
    weChatPayment() {
      //在这里请求接口,通过订单获得生成的二维码
      let user_json = localStorage.getItem("userinfo");
      let userInfo = JSON.parse(user_json);
      let data = {
        orderNumber: this.orderInfo.orderNumber,
        subjectId: this.subjectActive,
        userId: userInfo.id
      };
      this.$HTTP
        .executePost(this.$APIS.CREATE_WX_CODE_URL, data, this)
        .then(res => {
          if (res.code == 0) {
            this.payCodeUrl = res.data.code_url;
            this.wxPay = true;
            this.quertOrderStatus();
          } else {
            this.$message.success("获得支付二维码失败,请重试!");
          }
        });
      //  = 'weixin://wxpay/bizpayurl?pr=Khjd4GM00';

      //轮训请求订单的支付状态
    },
    // 关闭弹层 重置参数
    closeDialog() {
      this.wxPay = false;
    },
    alipayPayment() {
      // 支付宝支付
      let param = {
        orderNumber: this.orderInfo.orderNumber
      };
      // 请求支付宝支付接口
      this.$HTTP.executePost(this.$APIS.ALIPAY_PAY, param, this).then(res => {
        if (res.data.length) {
          this.html = res.data;
          this.$nextTick(() => {
            document.forms[0].submit();
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    isAgentMath() {
      // 判断是不是代理商
      if (this.isAgent) {
        // 是代理商
        // 学科是什么
        if (this.subjectActive == 9) {
          // 语文
          if (this.agentInfo.yuwenTimes > 0) {
            if (this.model != "client") {
              this.$message.error("请下载客户端答题！");
              this.shows = false;
            } else {
              this.$router.push({
                path: "/paper/paper",
                query: {
                  paper_id: this.paper.id,
                  app_id: 100,
                  order_number: "",
                  question_type: this.dialogActive,
                  test_id: this.testId
                }
              });
            }
            return false;
          }
        } else if (this.subjectActive == 10) {
          // 数学
          if (this.agentInfo.shuxueTimes > 0) {
            if (this.model != "client") {
              this.$message.error("请下载客户端答题！");
              this.shows = false;
            } else {
              this.$router.push({
                path: "/paper/paper",
                query: {
                  paper_id: this.paper.id,
                  app_id: 100,
                  order_number: "",
                  question_type: this.dialogActive,
                  test_id: this.testId
                }
              });
            }
            return false;
          }
        } else if (this.subjectActive == 11) {
          if (this.agentInfo.yingyuTimes > 0) {
            if (this.model != "client") {
              this.$message.error("请下载客户端答题！");
              this.shows = false;
            } else {
              this.$router.push({
                path: "/paper/paper",
                query: {
                  paper_id: this.paper.id,
                  app_id: 100,
                  order_number: "",
                  question_type: this.dialogActive,
                  test_id: this.testId
                }
              });
            }
            return false;
          }
        } else if (this.subjectActive == 12) {
          if (this.agentInfo.wuliTimes > 0) {
            if (this.model != "client") {
              this.$message.error("请下载客户端答题！");
              this.shows = false;
            } else {
              this.$router.push({
                path: "/paper/paper",
                query: {
                  paper_id: this.paper.id,
                  isnumber: "1",
                  order_number: "",
                  question_type: this.dialogActive,
                  test_id: this.testId
                }
              });
            }
            return false;
          }
        }
      }
    },
    buyProcurement(paperId) {
      this.shows = true;
      // 是否登陆的判断
      this.$HTTP.executeGet(this.$APIS.USER_ISLOGIN, this).then(response => {
        if (response.code == 0) {
          let userInfo = window.localStorage.getItem("userinfo");
          if (userInfo != undefined && userInfo != null) {
            this.getBalance(); // 去看看有没有余额 更新余额
            window.localStorage.setItem("isLogin", "true");
            // 判断是不是老vip用户
            if (this.isVip == 1) {
              sessionStorage.setItem("object_id", "");
              sessionStorage.setItem("object_type", "");
              if (this.model != "client") {
                this.$message.error("请下载客户端答题！");
                this.shows = false;
              } else {
                this.getPaperHavDo();
              }
              return false;
            }
            // 判断是不是代理商
            let paramsPaper = {
              userId: this.userInfo.id,
              subjectId: this.subjectActive,
              paperId: paperId,
              macAddress: this.$cookies.get("MachineId") || ""
            };
            // 判断是不是可以进试卷
            this.$axios
              .post(`vip/card/get-iscan-into-paper`, paramsPaper)
              .then(res => {
                const { status, data } = res;
                if (status === 200) {
                  // 0 可以进入 , 1.无会员 , 2.无当前学科会员,3.当前试卷无套数,4.会员卡未当前指定试卷 ,5.当前试卷面无次数
                  if (data.code === 0) {
                    sessionStorage.setItem("object_id", data.data.objectId);
                    sessionStorage.setItem("object_type", data.data.objectType);
                    if (data.data.status === 0) {
                      if (this.model != "client") {
                        this.$message.error("请下载客户端答题！");
                        this.shows = false;
                      } else {
                        // 有月卡先弹出一个提示框
                        if (this.dialogActive == 0) {
                          this.$confirm(
                            "确定后将消耗一次答题，请确认要测评吗？",
                            "提示",
                            {
                              confirmButtonText: "确定",
                              cancelButtonText: "取消",
                              type: "warning"
                            }
                          )
                            .then(() => {
                              this.getPaperHavDo();
                            })
                            .catch(() => {
                              this.shows = false;
                            });
                        } else {
                          this.getPaperHavDo();
                        }
                      }
                    } else if (data.data.status === 1) {
                      this.shows = false;
                      // this.$message.error('请购买会员后答题!')
                      this.getOrderList();
                      return false;
                    } else if (data.data.status === 2) {
                      this.shows = false;
                      this.$message.error("无当前学科会员,请购买当前学科会员!");
                      this.getOrderList();
                      return false;
                    } else if (data.data.status === 3) {
                      this.shows = false;
                      this.$message.error("当前试卷无可以使用的套数！");
                      this.getOrderList();
                      return false;
                    } else if (data.data.status === 4) {
                      this.shows = false;
                      this.$message.error(
                        "会员卡未当前指定试卷，请选择其它试卷作答！"
                      );
                      this.getOrderList();
                      return false;
                    } else if (data.data.status === 5) {
                      this.shows = false;
                      this.$message.error("当前试卷无次数！");
                      this.getOrderList();
                      return false;
                    }
                  } else {
                    this.shows = false;
                    this.$message.error("接口错误！");
                  }
                }
              });
          } else {
            this.$store.commit("changeIsShowLogin", true);
            this.shows = false;
            return false;
          }
        } else {
          try {
            cefJS.sendmsg("logout");
          } catch (error) {
            console.log(error);
          }
          this.$store.commit("changeIsShowLogin", true);
          this.shows = false;
          return false;
        }
      });
    },
    // 写一个函数来执行
    async getChance(cData) {
      let monthIsOk = false;
      let user_json = localStorage.getItem("userinfo");
      let userInfo = JSON.parse(user_json);
      for (let i = 0; i < cData.length; i++) {
        const element = cData[i];
        if (element.subjects.indexOf(this.subjectActive) != -1) {
          this.monthNum = element.paperNum;
          this.answerTimes = element.answerTimes;
          let sParams = {
            userId: userInfo.id,
            subjectId: this.subjectActive,
            createDate: new Date(element.createTime),
            endDate: new Date(element.createTime + element.indate)
          };
          await this.$HTTP
            .executePost(this.$APIS.GET_CARD_INFOPAPER_NUM, sParams, this)
            .then(res => {
              if (res.code === 0) {
                if (res.data.length) {
                  let isPaper = false; // 当前试卷是否存在
                  for (let j = 0; j < res.data.length; j++) {
                    const element = res.data[j];
                    if (element.paperId == this.paper.id) {
                      isPaper = true;
                    }
                  }
                  if (isPaper) {
                    // 存在
                    for (let z = 0; z < res.data.length; z++) {
                      const element2 = res.data[z];
                      if (element2.paperId == this.paper.id) {
                        if (element2.completeTimes < this.answerTimes) {
                          // 有月卡先弹出一个提示框
                          if (this.model != "client") {
                            this.$message.error("请下载客户端答题！");
                            this.shows = false;
                          } else {
                            this.$confirm(
                              "此操作会消耗月卡次数 确定要继续吗?",
                              "提示",
                              {
                                confirmButtonText: "确定",
                                cancelButtonText: "取消",
                                type: "warning"
                              }
                            )
                              .then(() => {
                                this.$router.push({
                                  path: "/paper/paper",
                                  query: {
                                    paper_id: this.paper.id,
                                    app_id: 100,
                                    order_number: "",
                                    question_type: this.dialogActive,
                                    test_id: this.testId
                                  }
                                });
                              })
                              .catch(() => {
                                this.shows = false;
                              });
                          }
                          return false;
                        } else {
                          monthIsOk = true;
                        }
                      }
                    }
                  } else {
                    // 不存在
                    if (res.data.length < this.monthNum) {
                      // 有月卡先弹出一个提示框
                      if (this.model != "client") {
                        this.$message.error("请下载客户端答题！");
                        this.shows = false;
                      } else {
                        this.$confirm(
                          "此操作会消耗月卡次数 确定要继续吗?",
                          "提示",
                          {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                          }
                        )
                          .then(() => {
                            this.$router.push({
                              path: "/paper/paper",
                              query: {
                                paper_id: this.paper.id,
                                app_id: 100,
                                order_number: "",
                                question_type: this.dialogActive,
                                test_id: this.testId
                              }
                            });
                          })
                          .catch(() => {
                            this.shows = false;
                          });
                      }
                      return false;
                    } else {
                      monthIsOk = true;
                    }
                  }
                } else {
                  // 有月卡先弹出一个提示框
                  if (this.model != "client") {
                    this.$message.error("请下载客户端答题！");
                    this.shows = false;
                  } else {
                    this.$confirm(
                      "此操作会消耗月卡次数 确定要继续吗?",
                      "提示",
                      {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                      }
                    )
                      .then(() => {
                        this.$router.push({
                          path: "/paper/paper",
                          query: {
                            paper_id: this.paper.id,
                            app_id: 100,
                            order_number: "",
                            question_type: this.dialogActive,
                            test_id: this.testId
                          }
                        });
                      })
                      .catch(() => {
                        this.shows = false;
                      });
                  }
                  return false;
                }
              }
            });
        }
      }
      // 走到这
      // this.isAgentMath()
      if (monthIsOk) {
        // 查询是否有订单
        this.$HTTP
          .executePost(
            this.$APIS.IS_HAVE_ORDER,
            {
              paperId: this.paper.id
            },
            this
          )
          .then(res => {
            if (!res.code && res.data != null) {
              //有订单
              this.orderInfo = res.data;
              // 查看订单状态
              this.$HTTP
                .executePost(
                  this.$APIS.QUERY_TRADE_STATUS,
                  { orderNumber: this.orderInfo.orderNumber },
                  this
                )
                .then(resD => {
                  if (resD.code == 0) {
                    // 支付成功
                    if (resD.data != null && resD.data == "1") {
                      if (this.model != "client") {
                        this.$message.error("请下载客户端答题！");
                        this.shows = false;
                      } else {
                        this.getPaperHavDo();
                      }
                      // 未支付
                    } else if (resD.data != null && resD.data == "0") {
                      let user_json = localStorage.getItem("userinfo");
                      let userInfo = JSON.parse(user_json);
                      this.$HTTP
                        .executePost(
                          this.$APIS.CREATE_ORDER,
                          {
                            tradeGoodsId: this.goodsId,
                            paperId: this.paper.id,
                            subjectId: this.paper.subjectId,
                            userId: userInfo.id
                          },
                          this
                        )
                        .then(res => {
                          this.orderInfo = res.data;
                        });
                      this.shows = false;
                      this.dialogVisible = true;
                    } else {
                      // 点击支付生成订单
                      let user_json = localStorage.getItem("userinfo");
                      let userInfo = JSON.parse(user_json);
                      this.$HTTP
                        .executePost(
                          this.$APIS.CREATE_ORDER,
                          {
                            tradeGoodsId: this.goodsId,
                            paperId: this.paper.id,
                            subjectId: this.paper.subjectId,
                            userId: userInfo.id
                          },
                          this
                        )
                        .then(res => {
                          this.orderInfo = res.data;
                          this.dialogVisible = true;
                          this.shows = false;
                        });
                    }
                  } else if (resD.code == 40004) {
                    this.dialogVisible = true;
                    this.shows = false;
                  }
                });
            } else {
              // 点击支付生成订单
              let user_json = localStorage.getItem("userinfo");
              let userInfo = JSON.parse(user_json);
              this.$HTTP
                .executePost(
                  this.$APIS.CREATE_ORDER,
                  {
                    tradeGoodsId: this.goodsId,
                    paperId: this.paper.id,
                    subjectId: this.paper.subjectId,
                    userId: userInfo.id
                  },
                  this
                )
                .then(res => {
                  this.orderInfo = res.data;
                  this.dialogVisible = true;
                  this.shows = false;
                });
            }
          });
      }
    },
    getBlockedOut(ind) {
      this.active = ind;
    },
    getSubjectList() {
      this.$HTTP
        .executePost(
          this.$APIS.GET_EXPERT_EVALUATION_SUBJECTID,
          { appId: 100 },
          this
        )
        .then(res => {
          if (!res.code) {
            const list = res.data;
            const subjectArr = [];
            for (let i = 0; i < list.length; i++) {
              const element1 = list[i].subjectId;
              for (let index = 0; index < this.subjectList.length; index++) {
                const element2 = this.subjectList[index];
                if (element1 == element2.id) {
                  subjectArr.push(element2);
                }
              }
            }
            subjectArr.splice(0, 0, subjectArr.splice(1, 1)[0]);
            console.log("subjectArr ==> ", subjectArr);
            let tempIndexs = [];
            subjectArr.forEach(item => {
              let index = this.subjectList.getFirstIndexByItem("id", item.id);
              console.warn("index ==> ", index);
              if (index != null) {
                tempIndexs.push(index);
              }
            });
            tempIndexs.sort();
            let result = [];
            tempIndexs.forEach(e => {
              result.push(this.subjectList[e]);
            });

            this.subjectData = result;
          } else {
            this.$message.error("调用接口失败");
          }
        });
    },
    wxEnter() {
      this.wxShow = true;
    },
    wxLeave() {
      this.wxShow = false;
    },
    toPaper(app_id, id) {
      if (this.model != "client") {
        this.$message.error("请下载客户端答题！");
        this.shows = false;
      } else {
        this.getPaperHavDo();
      }
    },
    toPaperDetail(id, val, goodsId) {
      this.$router.push({
        path: "/tfedu_common/expert",
        query: {
          id: this.$route.query.id,
          paper_id: id
        }
      });
      // tfedu_common/expert?id=9paper_id=1234
      // this.goodsId = goodsId
      // this.activeli = val
      // if(this.paperData[0].id == id) {
      //   this.active = 3
      // } else {
      //   this.active = 1
      // }
      // // this.$root.eventHub.$emit("subject-scroll-top");
      // // 获取第一个试卷
      // this.getPaperDetail(id);
    },
    // setStructure() {
    //   this.structure = !this.structure;
    // },
    // 筛选科目
    // selectSubject(ind) {
    //   // this.active = 1
    //   this.tabActive = 0;
    //   if (ind == "no") {
    //     delete this.params.subjectId;
    //     this.subjectActive = -1;
    //   } else {
    //     sessionStorage.setItem('subjectId', ind)
    //     this.params.subjectId = ind;
    //     this.subjectActive = ind;
    //     this.$router.push({
    //       path: "/tfedu_common/expert",
    //       query: {
    //         id: ind
    //       }
    //     })
    //   }
    //   this.getPaperList();
    // },

    // 获取数据
    // getPaperList() {
    //   this.loading = true;
    //   this.$HTTP
    //     .executePost(this.$APIS.GET_PAPER_PARAM, this.params, this)
    //     .then((res) => {
    //       this.loading = false;
    //       if (res.code == 0) {
    //         this.paperData = res.data.list;
    //         this.params.pageIndex = res.data.pageIndex;
    //         this.totalCount = res.data.total;

    //         // 获取第一个试卷
    //         let id = res.data.list[0].id || this.$route.query.paper_id
    //         this.getPaperDetail(res.data.list[0].id || id);
    //         this.goodsId = res.data.list[0].tradeGoodsInfo.id
    //         this.activeli = id
    //       }
    //     });
    // },
    // 第一次获取
    getFistPaperList() {
      this.loading = true;
      this.$HTTP
        .executePost(this.$APIS.GET_PAPER_PARAM, this.params, this)
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.paperData = res.data.list;
            this.params.pageIndex = res.data.pageIndex;
            this.totalCount = res.data.total;

            if (this.$route.query.paper_id) {
              this.getPaperDetail(this.$route.query.paper_id);
              if (this.$route.query.paper_id == res.data.list[0].id) {
                this.active = 1;
              } else {
                this.active = 1;
              }
              for (let i = 0; i < res.data.list.length; i++) {
                const goods = res.data.list[i];
                if (this.$route.query.paper_id == goods.id) {
                  this.goodsId = goods.tradeGoodsInfo.id;
                }
              }
            } else {
              this.getPaperDetail(res.data.list[0].id);
              this.goodsId = res.data.list[0].tradeGoodsInfo.id;
            }
          }
          this.paperLoading = false;
        });
    },
    // 获取试卷详情
    getPaperDetail(id) {
      this.detailLoading = true;
      this.$HTTP
        .executePost(this.$APIS.GET_PAPER_DETAIL, { paperId: id }, this)
        .then(res => {
          if (res.code == 0) {
            this.paper = res.data;

            let isLogin = window.localStorage.getItem("isLogin");
            if (isLogin) {
              let user_json = localStorage.getItem("userinfo");
              let userInfo = JSON.parse(user_json);
              this.getActiveStatus(userInfo.createTime, this.subjectActive);
            }
          }
          this.detailLoading = false;
          this.paperLoading = false;
        });
    },
    // 获取活动期间购买的试卷总数
    getActivePayAlltotal(beginTime, endTime) {
      this.$axios
        .get(`alipay/count-order/${beginTime}/${endTime}`)
        .then(res => {
          const { status, data } = res;
          if (status === 200) {
            if (data.code === 0) {
              this.paperAlltotal = data.data.count;
            }
          }
        })
        .catch(err => {
          // this.$message.error('请求出错')
        });
    },
    // 获取单科试卷购买的次数
    getSubjectPayAllNumber(beginTime, endTime, subjectId) {
      this.$axios
        .get(`alipay/count-order/${beginTime}/${endTime}/${subjectId}`)
        .then(res => {
          const { status, data } = res;
          if (status === 200) {
            if (data.code === 0) {
              this.singleFamily = data.data.count;
            }
          }
        })
        .catch(err => {
          // this.$message.error('请求出错')
        });
    },
    // 判断当前时间下是否有正在进行的活动
    getActiveStatus(timestamp, subjectId) {
      this.$axios
        .get(`activity-new-reg/get-by-timestamp-underway/${timestamp}`)
        .then(res => {
          const { status, data } = res;
          if (status === 200) {
            if (data.code === 0) {
              this.hasActive = true;
              this.activeInfo = data.data;
              this.activePrice = this.activeInfo.paice;
              let startTime = this.activeInfo.beginTime;
              let endTime = this.activeInfo.endTime;
              this.limitSubject = this.activeInfo.type;

              if (this.activeInfo.type === 0) {
                // 不限学科
                this.getActivePayAlltotal(startTime, endTime);
              } else if (this.activeInfo.type === 1) {
                // 限学科
                this.getSubjectPayAllNumber(startTime, endTime, subjectId);
              }
              for (let i = 0; i < this.activeInfo.subjectList.length; i++) {
                this.subjectShowPreferential.push(
                  this.activeInfo.subjectList[i].subjectId
                );
              }
            } else {
              this.hasActive = false;
            }
          }
        })
        .catch(err => {
          // this.$message.error('请求出错')
        });
    },
    // 有无订单
    getOrderList() {
      // this.isAgentMath()
      //查询是否有订单
      this.$HTTP
        .executePost(
          this.$APIS.IS_HAVE_ORDER,
          {
            paperId: this.paper.id
          },
          this
        )
        .then(res => {
          if (!res.code && res.data != null) {
            //有订单
            this.orderInfo = res.data;
            // 查看订单状态
            this.$HTTP
              .executePost(
                this.$APIS.QUERY_TRADE_STATUS,
                { orderNumber: this.orderInfo.orderNumber },
                this
              )
              .then(resD => {
                if (resD.code == 0) {
                  // 支付成功
                  if (resD.data != null && resD.data == "1") {
                    if (this.model != "client") {
                      this.$message.error("请下载客户端答题！");
                      this.shows = false;
                    } else {
                      // this.$router.push({
                      //   path: '/paper/paper',
                      //   query: {
                      //     paper_id: this.paper.id,
                      //     app_id: 100,
                      //     order_number: this.orderInfo.orderNumber,
                      //     question_type: 4
                      //   }
                      // })
                      this.getPaperHavDo();
                    }
                  } else if (resD.data != null && resD.data == "0") {
                    let user_json = localStorage.getItem("userinfo");
                    let userInfo = JSON.parse(user_json);
                    this.$HTTP
                      .executePost(
                        this.$APIS.CREATE_ORDER,
                        {
                          tradeGoodsId: this.goodsId,
                          paperId: this.paper.id,
                          subjectId: this.paper.subjectId,
                          userId: userInfo.id
                        },
                        this
                      )
                      .then(res => {
                        this.orderInfo = res.data;
                      });
                    this.shows = false;
                    setTimeout(() => {
                      this.dialogVisible = true;
                    }, 300);
                  } else {
                    // 点击支付生成订单
                    let user_json = localStorage.getItem("userinfo");
                    let userInfo = JSON.parse(user_json);
                    this.$HTTP
                      .executePost(
                        this.$APIS.CREATE_ORDER,
                        {
                          tradeGoodsId: this.goodsId,
                          paperId: this.paper.id,
                          subjectId: this.paper.subjectId,
                          userId: userInfo.id,
                          tradeGoodsId: this.goodsId
                        },
                        this
                      )
                      .then(res => {
                        this.orderInfo = res.data;
                        setTimeout(() => {
                          this.dialogVisible = true;
                        }, 300);
                        this.shows = false;
                      });
                  }
                } else if (resD.code == 40004) {
                  setTimeout(() => {
                    this.dialogVisible = true;
                  }, 300);
                  this.shows = false;
                }
              });
            // this.alipayPayment()
          } else {
            // 点击支付生成订单
            let user_json = localStorage.getItem("userinfo");
            let userInfo = JSON.parse(user_json);
            this.$HTTP
              .executePost(
                this.$APIS.CREATE_ORDER,
                {
                  tradeGoodsId: this.goodsId,
                  paperId: this.paper.id,
                  subjectId: this.paper.subjectId,
                  userId: userInfo.id
                },
                this
              )
              .then(res => {
                this.orderInfo = res.data;
                setTimeout(() => {
                  this.dialogVisible = true;
                }, 300);
                this.shows = false;
              });
          }
        })
        .catch(err => {
          this.$message.error("无订单");
          return false;
        });
    },
    // 获取余额信息
    getBalance() {
      this.$HTTP
        .executeGet(`${this.$APIS.GET_USER_BLANCE}/${this.userInfo.id}`, this)
        .then(res => {
          const { data, code, msg } = res;
          if (code === 0) {
            this.price = data;
          } else {
            this.$message.error(msg);
          }
        });
    }
  },
  created() {
    this.activeli = this.$route.query.paper_id || 0;
    // 兼容客户端
    let source = localStorage.getItem("model") || this.$route.query.model || "";
    this.model = source;
    localStorage.setItem("model", source);
    try {
      CefSharp.BindObjectAsync("cefJS");
    } catch (error) {
      console.log(error);
    }
    // 首版隐藏
    // this.$store.dispatch('selectTabType', 'expert')
    // 首版展示
    this.$store.dispatch("selectTabType", "home");

    this.getSubjectList();
    this.params.subjectId =
      this.$route.query.id || sessionStorage.getItem("subjectId") || 10;
    this.subjectActive =
      this.$route.query.id || sessionStorage.getItem("subjectId") || -1;
    this.params.dateType = this.$route.query.time;
    this.timeActive = this.$route.query.time || -1;
    // this.getFistPaperList();
    this.getPaperDetail(this.$route.query.paper_id);

    if (this.$route.query.code != null && this.$route.query.code != 0) {
      this.dialogVisible = true;
    }
    let user_json = localStorage.getItem("userinfo");
    this.userInfo = JSON.parse(user_json);
    // 代理商每学科只能做五套试卷
    this.$HTTP
      .executeGet(`${this.$APIS.GET_BY_CHAGEID}/${this.userInfo.id}`, this)
      .then(res => {
        if (!res.code) {
          // 是代理商
          if (res.data != null && res.data.id) {
            // 是代理商
            this.isAgent = true;
            this.agentInfo = res.data;
          }
        } else {
          console.log("不是代理商");
        }
      });
    // 获取用户余额信息
    this.getBalance();
    // this.getActiveStatus(this.userInfo.createTime, this.subjectActive)
    this.isVip =
      this.userInfo.type != null && this.userInfo.type
        ? +this.userInfo.type
        : "";
  },
  mounted() {
    $("body").css("background", "#f5f5f5");
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  iframe {
    width: 100%;
    border: none;
    margin-bottom: 40px;
  }
}
.nocountent {
  width: 400px;
  margin: 0 auto;
  margin-top: 50px;
  position: relative;
  img {
    width: 100%;
  }
  p {
    color: #a9a9a9;
    font-size: 18px;
    width: 100%;
    position: absolute;
    bottom: 5px;
    text-align: right;
    padding-right: 40px;
  }
}
.select_subject-box-main_cont {
  width: 1520px;
  height: 100%;
  margin: 0 auto;
  position: relative;

  /deep/ .pay-dialod-visible {
    width: 612px;
    height: 530px;
    background-color: #fff;
    padding: 0;
    .count {
      .wx_box_success {
        h3 {
          font-size: 30px;
          color: #585858;
          text-align: center;
        }
      }
      .wx_box {
        background-color: #fff;
        margin-top: 15px;
        h3 {
          font-size: 18px;
          color: #585858;
          text-align: center;
        }

        .price {
          text-align: center;
          font-size: 18px;
          color: #585858;
          margin-top: 20px;

          .p_num {
            font-size: 28px;
            text-decoration: line-through;
          }

          .p_num_new {
            font-size: 28px;
            color: #e50001;
          }
        }
      }
      .zfb_box {
        background-color: #fff;
        margin-top: 20px;
        h3 {
          font-size: 18px;
          color: #585858;
          text-align: center;
        }
        .foot-vip {
          .text-info {
            font-size: 16px;
            text-align: center;
          }
          .btn-container {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 20px;
            /deep/ .el-button {
              background: #1890ff;
              color: #fff;
              margin-top: 20px;
            }

            .el-button {
              background: #1890ff;
              color: #fff;
            }
          }
        }
      }
      width: 100%;
      height: 100%;
      position: relative;
      .has_active_price {
        font-size: 28px;
        color: red;
        line-height: 58px;
        margin-left: 38px;
        width: 200px;

        .lineation {
          font-size: 16px;
          color: #a6a6a6;
        }

        .vipPreferential {
          display: block;
        }
      }
      .vip_card {
        width: 290px;
        float: right;
        height: auto;
        margin-right: 10px;
        margin-top: 10px;
        cursor: pointer;
      }
      .right_c {
        width: 100%;
        height: 300px;
        float: right;
        background-color: #fff;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .wx {
          width: 190px;
          float: left;
          height: 60px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          cursor: pointer;
        }

        .wx:hover {
          box-shadow: 10px 10px 10px #ddd;
        }

        .zfb {
          width: 190px;
          height: 60px;
          float: right;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .zfb:hover {
          box-shadow: 10px 10px 10px #ddd;
        }
      }
      .right {
        .right_QrCode {
          width: 200px;
          margin: 10px auto;
          .right_QrCode_img {
            width: 200px !important;
            height: 200px !important;
          }
          img {
            width: 200px !important;
            height: 200px !important;
          }
        }
        .imageOne {
          width: 100%;
        }
      }

      .pOne {
        width: 100%;
        color: #575757;
        margin-top: 10px;
        font-size: 16px;
        float: right;
        text-align: center;

        .pay_r {
          float: right;
          cursor: pointer;
        }
      }
    }
  }

  /deep/ .paper-type-dialod-visible {
    width: 570px;
    height: auto;
    .el-dialog__header {
      padding: 0;
      height: 79px;
      background: #5c307d;
      line-height: 79px;
      .el-dialog__title {
        color: #fff;
      }
      .el-dialog__headerbtn {
        .el-dialog__close {
          color: #fff;
          font-size: 24px;
        }
      }
    }
    .el-dialog__body {
      ul {
        li {
          height: 68px;
          line-height: 68px;
          border-bottom: 1px dashed #afafaf;
          margin-top: 20px;
          font-size: 20px;
          color: #3c3c3c;

          .selest {
            width: 48px;
            height: 48px;
            float: right;
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
      button {
        width: 120px;
        height: 42px;
        background: #5c307d;
        color: #fff;
        border: none;
        border-radius: 4px;
        margin-top: 20px;
        margin-left: 38%;
        cursor: pointer;
      }
    }
  }

  /deep/ .has_active {
    .new_user {
      margin-left: 38px;
      border: 1px solid #ff6672;
      background: #ffdede;
      display: inline-block;
      border-radius: 6px;
      padding: 7px 14px;
      font-size: 16px;
    }

    .new_user_name {
      margin-left: 38px;
      margin-top: 14px;
      font-size: 16px;
      color: #a6a6a6;
    }
    .pay_type {
      margin-top: 53px;
      margin-left: 38px;
      font-size: 20px;
      color: #585858;
    }
    .has_active_price {
      font-size: 28px;
      color: red;
      line-height: 58px;
      margin-left: 38px;
      width: 200px;

      .lineation {
        font-size: 16px;
      }
    }

    .vip_card {
      width: 290px;
      float: right;
      height: auto;
      margin-right: 10px;
      margin-top: 10px;
      cursor: pointer;
    }
    .tips_d {
      margin-left: 38px;
      margin-top: 14px;
      font-size: 16px;
      color: #a6a6a6;
    }

    .right_d {
      width: 100%;
      float: right;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding-bottom: 20px;

      .wx {
        margin-top: 26px;
        padding: 6px 18px;
        width: 190px;
        float: left;
        height: 60px;
        position: relative;
        border-radius: 6px;
        background-color: #fff;
        border: 1px solid #a6a6a6;
        img {
          width: 100%;
          height: 100%;
        }
        cursor: pointer;
      }

      .wx:hover {
        box-shadow: 10px 10px 10px #ddd;
      }

      .zfb {
        margin-top: 26px;
        padding: 6px 18px;
        border-radius: 6px;
        width: 190px;
        height: 60px;
        float: right;
        cursor: pointer;
        border: 1px solid #a6a6a6;
        background-color: #fff;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .zfb:hover {
        box-shadow: 10px 10px 10px #ddd;
      }
    }
  }
  .pay_types {
    margin-top: 53px;
    margin-left: 38px;
    font-size: 20px;
    color: #585858;
    text-align: left;
  }
  .right_f {
    width: 100%;
    float: right;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;

    .wx {
      margin-top: 26px;
      padding: 6px 18px;
      width: 190px;
      float: left;
      height: 60px;
      position: relative;
      border-radius: 6px;
      background-color: #fff;
      border: 1px solid #a6a6a6;
      img {
        width: 100%;
        height: 100%;
      }
      cursor: pointer;
    }

    .wx:hover {
      box-shadow: 10px 10px 10px #ddd;
    }

    .zfb {
      margin-top: 26px;
      padding: 6px 18px;
      border-radius: 6px;
      width: 190px;
      height: 60px;
      float: right;
      cursor: pointer;
      border: 1px solid #a6a6a6;
      background-color: #fff;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .zfb:hover {
      box-shadow: 10px 10px 10px #ddd;
    }

    .balance {
      margin-top: 26px;
      border-radius: 6px;
      width: 480px;
      height: 60px;
      cursor: pointer;
      border: 1px solid #a6a6a6;
      background-color: #fff;
      .left {
        float: left;
        width: 330px;
        margin-left: 18px;
        img {
          width: 47px;
          float: left;
          margin-top: 9px;
          margin-right: 10px;
        }
        .msg {
          float: left;
          line-height: 60px;
          font-size: 18px;
        }
      }
      .right {
        float: right;
        width: 88px;
        height: 58px;
        color: #fff;
        background: #5c307d;
        border-radius: 4px;
        border: none;
        outline: none;
        font-size: 18px;
        cursor: pointer;
      }
    }
    .balance:hover {
      box-shadow: 10px 10px 10px #ddd;
    }
  }

  .main-list-left {
    width: 310px;
    // position: absolute;
    position: fixed;
    top: 144px;
    bottom: 63px;
    left: 190px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;
    z-index: 2;

    .list_bottom {
      position: absolute;
      top: 75px;
      bottom: 20px;
      left: 0;
      right: 0;
      overflow-y: auto;
      overflow-x: hidden;
      overflow-y: scroll;
      scrollbar-color: transparent transparent;
      scrollbar-track-color: transparent;
      -ms-scrollbar-track-color: transparent;
      --scrollbar-width: thin; /* or `auto` or `none` */
    }

    .list_bottom::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 4px;
      height: 6px;
    }
    .list_bottom::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: rgba(0, 0, 0, 0.2);
      box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }

    .tabs {
      width: 300px;
      height: 50px;
      padding-top: 1px;
      margin-top: 25px;
      border-bottom: 1px solid #aaaaaa;
      font-size: 20px;
      color: #aaaaaa;
      .paper-title {
        margin-left: 18px;
      }

      .tab-left {
        width: 134px;
        height: 48px;
        border: 1px solid #aaaaaa;
        float: left;
        margin-right: 10px;
        text-align: center;
        line-height: 48px;
        border-bottom: none;
        color: #585858;

        .top {
          margin-left: 10px;
          width: 13px;
          height: 17px;
          vertical-align: -1px;
        }
      }

      .tab-left:hover {
        color: #fff;
        background-color: #5c307d;
        border-color: #5c307d;
        cursor: pointer;
      }

      .tab-active {
        color: #fff;
        background-color: #5c307d;
        border-color: #5c307d;
        cursor: pointer;
      }

      .tab-right {
        cursor: pointer;
        margin-right: 22px;
        margin-top: 15px;
        float: right;
        width: 19px;
        height: 19px;
      }
    }

    .tabel {
      width: 100%;
      height: auto;
      margin-top: 15px;

      li {
        width: 100%;
        color: #5a5a5a;
        font-size: 20px;
        cursor: pointer;
        list-style: none;
        position: relative;
        padding: 5px 0;

        .p-name {
          line-height: 30px;
          padding-left: 20px;
          padding-right: 20px;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        span {
          display: block;
          min-width: 22px;
          height: 22px;
          border-radius: 11px;
          border: 1px solid #ff9f9f;
          font-size: 12px;
          position: absolute;
          text-align: center;
          line-height: 22px;
          color: #f00000;
          background-color: #ffdfdf;
          left: 24px;
          top: 8px;
        }

        .free {
          border: 1px solid #07d237;
          background-color: #ceffe4;
          color: #45db64;
        }
      }
      li:hover {
        color: #0072ff;
      }
      .active {
        color: #0072ff;
      }
    }
  }

  .main-detail-right {
    width: 80%;
    height: 100%;
    // padding-left: 310px;
    position: relative;
    margin: 0 auto;
    .detail-right-box {
      position: absolute;
      bottom: 20px;
      top: 0px;
      // bottom:20px;
      right: 0;
      // left: 320px;
      width: 100%;
      background-color: #fff;
    }
    .condition {
      position: fixed;
      top: 72px;
      left: 0;
      right: 0;
      height: 72px;
      background-color: #f5f5f5;
      li {
        height: 72px;
        font-size: 20px;
        display: flex;
        margin: 0 auto;
        width: 1000px;

        .left {
          width: 78px;
          line-height: 72px;
          margin-left: 100px;
          color: #aaaaaa;
        }

        .right {
          flex: 1;
          height: auto;
          display: flex;
          flex-wrap: wrap;
          cursor: pointer;

          .span {
            width: 90px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            border-radius: 18px;
            float: left;
            margin-right: 25px;
            color: #585858;
            margin-top: 18px;
            cursor: pointer;
          }

          .span:hover {
            color: #0072ff;
            background: #fff;
          }

          .active {
            color: #0072ff;
            background: #fff;
          }
        }
      }

      .li-bottom {
        border-bottom: 1px solid #aaaaaa;
      }
    }

    .center {
      width: 100%;
      height: 266px;
      margin: 0 auto;
      margin-top: 72px;

      .left {
        float: left;
        width: 380px;
        height: 246px;
        margin-top: 20px;
        margin-left: 32px;
      }

      .right {
        width: 730px;
        float: left;
        margin-top: 20px;
        margin-left: 36px;

        .title {
          font-size: 28px;
          color: #565656;
          line-height: 52px;
          height: 104px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 12px;
        }

        .m-r {
          margin-right: 75px;
        }

        .m-r-b {
          margin-right: 64px;
        }

        .p-time {
          font-size: 18px;
          line-height: 33px;
          color: #a3a3a3;

          .text {
            color: #575757;
          }
        }

        .price {
          width: 100%;
          margin-top: 40px;
          .time-limit {
            display: inline-flex;
            font-size: 14px;
            .left-text {
              font-size: 32px;
              color: #fffc00;
              height: 55px;
              width: 180px;
              text-align: center;
              line-height: 55px;
              background-image: linear-gradient(to right, #fc9c21, #f4152a);
            }
            .right-text {
              background-color: #5c307d;
              height: 55px;
              width: 240px;
              display: inline-flex;
              line-height: 55px;
              .first {
                font-size: 18px;
                color: #fffc00;
                line-height: 63px;
                margin-left: 30px;
              }
              .second {
                font-size: 18px;
                color: red;
                text-shadow: -1px 0 white, 0 1px white, 1px 0 white,
                  0 -1px white;
                .price {
                  font-size: 32px;
                }
              }
              .original {
                margin-left: 20px;
                line-height: 63px;
                font-size: 18px;
                color: #fffc00;
                text-decoration: line-through;
              }
            }
          }
          .button-right {
            width: 148px;
            height: 43px;
            border-radius: 22px;
            background-color: #5c307d;
            color: #ffffff;
            border: none;
            cursor: pointer;
            font-size: 21px;
            float: right;
            margin-top: 10px;
            margin-right: 40px;
          }
        }
      }
    }

    .introduce {
      width: 100%;
      padding: 0 20px;
      margin-top: 33px;
      background: #ffffff;
      border-radius: 12px;
      margin-bottom: 50px;

      .pic {
        width: 100%;
      }

      &-tab {
        padding-top: 22px;
        width: 100%;
        font-size: 21px;

        ul {
          height: 44px;
          border-bottom: 1px solid #c7c7c7;
          width: 100%;

          li {
            float: left;
            width: 100px;
            text-align: center;
            margin-left: 45px;
            line-height: 40px;
            color: #5a5a5a;
          }

          li:hover {
            border-bottom: 4px solid #5c307d;
            box-sizing: border-box;
            cursor: pointer;
          }

          .active {
            border-bottom: 4px solid #5c307d;
            box-sizing: border-box;
          }

          .first-li {
            width: 200px;
          }
        }
      }
    }
  }

  .handle {
    height: 44px;
    line-height: 44px;
    text-align: right;
    font-size: 18px;
    color: #5c307d;
    cursor: pointer;

    .top {
      margin: 3px 12px;
    }

    .bottom {
      margin: 0px 12px;
    }
  }

  .no-content {
    margin-top: 80px;

    p {
      color: #585858;
      font-size: 16px;
      text-align: center;
    }
  }
  .tabel-fk {
    width: 100%;
    height: auto;
    padding: 3px;

    li {
      width: 100%;
      margin-top: 20px;
      margin-bottom: 9px;
      cursor: pointer;
      position: relative;

      .p-img {
        width: 270px;
        height: 175px;
        display: block;
        margin-left: 15px;
        padding-top: 15px;
        /* position: relative; */
        img {
          width: 100%;
          height: 100%;
          display: block;
          /*width: 270px;
          height: 175px;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          transition: width 0.3s, height 0.3s, left 0.3s, top 0.3s; */
        }
        /* img:hover {
          left: -6px;
          top: -6px;
          width: 284px;
          height: 185px;
        } */

        /* .active {
          left: -6px;
          top: -6px;
          width: 284px;
          height: 185px;
        } */
      }

      .p-name {
        margin: 10px auto 10px 15px;
        line-height: 33px;
        color: #585858;
        width: 270px;
        font-size: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .label {
        position: absolute;
        top: 8px;
        right: 10px;
        width: 80px;
        height: 80px;

        img {
          width: 100%;
          height: 100%;
        }
        span {
          display: block;
          transform: rotate(45deg);
          color: #fff;
          font-size: 14px;
          position: absolute;
          top: 0;
          left: 0;
          width: 80px;
          height: 80px;
          line-height: 50px;
          text-align: center;
        }
      }
    }
    li:hover {
      box-shadow: 0 3px 9px 0 #595959;
    }
    .active {
      box-shadow: 0 3px 9px 0 #595959;
    }
  }
}
.shade {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;

  .tenorless {
    width: 100%;
    height: 100%;
    line-height: 172px;
    text-align: center;
    font-size: 18px;
    color: #ff5a00;
  }
}

.v-enter {
  opacity: 0;
  transform: translateY(100%);
}

.v-leave-to {
  opacity: 0;
  transform: translateY(-100%);
  // 解决页面从上往下位移问题
  position: absolute;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.35s ease;
}
</style>